const mediaSubmissionStatusOptions = {
  PRESIGNED: 'PRESIGNED',
  UPLOAD_S3_START: 'UPLOAD_S3_START',
  UPLOAD_S3_SUCCESS: 'UPLOAD_S3_SUCCESS',
  UPLOAD_S3_ERROR: 'UPLOAD_S3_ERROR',
  SUBMITTED: 'SUBMITTED',
};

export default mediaSubmissionStatusOptions;



// WEBPACK FOOTER //
// ./src/constants/media-submissions-status.js